import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Result, Skeleton } from 'antd'

//
import { getForSave } from 'core/application/account/employeeSignup'
import groupHraSignupController from 'core/application/account/employeeSignup'
import perksSignupController from 'core/application/account/perksEmployeeSignup'
import { ProductIds } from 'core/application/commons/config'

import useQueryRequest from 'common/hooks/useQueryRequest'
import useUrlQueryParam from 'common/hooks/useUrlQueryParam'

import { ROUTE_PATHS } from 'common/routePaths'

import { queryRequest } from '../../../common/RequestUtils'
import EmployeeSignup from '../EmployeeSignup'

//
import './eligibleEmployee.less'

const EligibleEmployeeSignup = () => {
  const { t } = useTranslation()
  const code = useUrlQueryParam('code')
  const [user, isUserLoading, , , hasUserError] = useQueryRequest(null, () => getForSave(code), {
    showErrors: false,
  })

  const headerTitle =
    user?.productId === ProductIds.Perks
      ? 'PeopleKeep WorkPerks Management'
      : user?.productId === ProductIds.QsehraId
      ? 'PeopleKeep QSEHRA Customer value'
      : 'PeopleKeep Group Coverage HRA Management'

  const signupHandler = user
    ? user.productId === ProductIds.Perks
      ? perksSignupController
      : groupHraSignupController
    : () => Promise.resolve()

  return (
    <>
      <Skeleton active={true} loading={isUserLoading}>
        {user && (
          <EmployeeSignup
            initialValues={{
              ...user,
            }}
            headerTitle={headerTitle}
            signupFlowPath={ROUTE_PATHS.ELIGIBLE_EMPLOYEE_SIGNUP_FLOW}
            signupController={signupHandler}
          />
        )}
      </Skeleton>
      {!user && hasUserError && (
        <div className="invitation-message-container">
          <Result
            status="404"
            title={t('ee-signup.invalid-invitation-title-label')}
            subTitle={t('ee-signup.invalid-invitation-message-label')}
            extra={t('ee-signup.invalid-invitation-message-label2')}
          />
        </div>
      )}
    </>
  )
}

export default EligibleEmployeeSignup
